module.exports = __webpack_public_path__ + "img/9788954431514.830f8dc0.jpg";